<template>
  <div class="home-container">
    <!-- 搜索区域 -->
    <Card class="search-card" dis-hover>
      <Form inline class="search-form">
        <FormItem>
          <Input 
            v-model="search.secret_id" 
            placeholder="请输入SecretId" 
            clearable
            prefix="ios-search"
            class="search-input"
          />
        </FormItem>
        <FormItem>
          <Input 
            v-model="search.name" 
            placeholder="请输入应用名称" 
            clearable
            prefix="ios-search"
            class="search-input"
          />
        </FormItem>
        <FormItem>
          <Button icon="ios-search" type="primary" @click="pageChange(1)" class="search-btn">搜索</Button>
          <Button style="margin-left: 8px;" @click="resetSearch">重置</Button>
        </FormItem>
      </Form>
    </Card>

    <!-- 应用列表 -->
    <Card class="app-list-card" dis-hover>
      <div slot="title" class="card-title-wrapper">
        <div class="card-title">
          <Icon type="ios-apps" size="20" />
          <span>我的应用</span>
        </div>
        <Button type="primary" @click="addModal.show = true" class="add-app-btn">
          <Icon type="ios-add-circle-outline" />
          添加应用
        </Button>
      </div>
      <div class="app-list-wrapper" style="position: relative;">
        <Spin fix v-if="loading"></Spin>
        <Row :gutter="24" :wrap="true" v-if="!loading && data.length > 0">
          <Col :xl="8" :lg="8" :md="12" :sm="24" :xs="24" v-for="(item, index) in data" :key="index">
            <div class="apply-item">
              <div class="item-tag">
                <Icon type="ios-checkmark-circle" size="14" />
                <span>已上线</span>
              </div>
              <div class="item-img">
                <img :src="item.thumb || '/static/default-app.png'" alt="应用图标" />
              </div>
              <div class="item-info">
                <div class="info-title">{{ item.name }}</div>
                <div class="info-row">
                  <Icon type="ios-key" size="14" />
                  <span class="info-label">SecretId:</span>
                  <span class="info-value">{{ item.secret_id }}</span>
                </div>
                <div class="info-row">
                  <Icon type="ios-phone-portrait" size="14" />
                  <span class="info-label">绑定设备:</span>
                  <span class="info-value">{{ item.device || 0 }}台</span>
                </div>
                <div class="info-row">
                  <Icon type="ios-cube" size="14" />
                  <span class="info-label">设备库量:</span>
                  <span class="info-value">{{ item.remaining || 0 }}/台</span>
                  <span class="info-link" @click="openDeviceModal(item)">修改套餐</span>
                </div>
                <div class="info-ai">
                  <div class="ai-row">
                    <Icon type="ios-flash" size="14" />
                    <span class="info-label">AI资源点:</span>
                    <Tag :color="aiConfigInfo(item.id).is_enabled ? 'success' : 'error'">
                      {{ aiEnableText(item.id) }}
                    </Tag>
                  </div>
                  <div class="ai-row" v-if="isExpired(item.id)">
                    <Icon type="ios-warning" size="14" color="#ed4014" />
                    <span class="info-label">期限:</span>
                    <span class="info-value text-danger">已到期</span>
                  </div>
                  <div class="ai-row" v-else-if="aiConfigInfo(item.id).expire_enabled && aiConfigInfo(item.id).expire_time">
                    <Icon type="ios-time" size="14" />
                    <span class="info-label">期限:</span>
                    <span class="info-value">{{ formatExpireTime(item.id) }}</span>
                  </div>
                  <div class="ai-row">
                    <Icon type="ios-lock" size="14" />
                    <span class="info-label">封顶:</span>
                    <span class="info-value">{{ limitDisplay(item.id) }}</span>
                  </div>
                </div>
              </div>
              <div class="item-actions">
                <Button @click="openResourceModal(item)" class="action-btn">
                  <Icon type="ios-settings" />
                  资源点配置
                </Button>
                <Button type="primary" class="action-btn-primary" @click="toUrl('/apply?secretId='+item.secret_id)">
                  <Icon type="ios-create" />
                  应用管理
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <div v-if="!loading && data.length === 0" class="empty-state">
          <Icon type="ios-apps-outline" size="64" color="#c5c8ce" />
          <p>暂无应用，点击上方"添加应用"创建第一个应用</p>
        </div>
        <Page 
          v-if="search.total > 0"
          class-name="page-r" 
          :total="search.total" 
          :current="search.page"
          :page-size="search.pageSize" 
          :page-size-opts="[10,15,20,30]" 
          show-total 
          show-sizer
          @on-change="pageChange" 
          @on-page-size-change="pageSizeChange"
        />
      </div>
    </Card>
    <Modal v-model="addModal.show" title="添加应用" width="800" @on-cancel="cancelModal" class-name="vertical-center-modal">
      <Form ref="addModalForm" :model="addModal.data" label-colon label-position="top">
        <FormItem label="应用名称" required>
          <Input v-model="addModal.data.name" placeholder="请输入应用名称"></Input>
        </FormItem>
        <FormItem label="图片">
          <div style="display: flex">
            <div v-if="addModal.data.thumb" style="width: 75px; height: 75px; margin-right: 12px;">
              <img :src="addModal.data.thumb" alt="" style="width: 100%; height: 100%;" />
            </div>
            <Uploads :action="ApiUrl+'/adm/upload_img'" :data="{dir:'img_temp',type:'base64'}" style="display: inline-block;" @upload_succ="uploadSuccess" />
          </div>
        </FormItem>
        <FormItem label="回调地址" required>
          <div style="display: flex">
            <Input v-model="addModal.data.dev_forward_url" placeholder="请输入回调地址">
              <template #prepend>
                <Select v-model="addModal.data.forwardStart" style="width: 80px">
                  <Option value="http">http://</Option>
                  <Option value="https">https://</Option>
                </Select>
              </template>
            </Input>
          </div>
        </FormItem>
        <FormItem label="IP白名单">
          <Input v-model="addModal.data.ip_white_list" type="textarea" :autosize="{minRows: 5}" placeholder="请输入IP白名单"></Input>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="cancelModal">取消</Button>
        <Button type="primary" @click="confirmModal">确定</Button>
      </template>
    </Modal>
    <Modal 
      v-model="resourceModal.show" 
      :title="'资源点配置 - ' + resourceModal.title" 
      class-name="vertical-center-modal resource-config-modal" 
      width="600"
      @on-cancel="closeResourceModal"
    >
      <Form :label-width="120" label-colon>
        <FormItem label="启用状态">
          <div class="switch-wrapper">
            <i-Switch 
              v-model="resourceModal.form.is_enabled" 
              :true-value="1" 
              :false-value="0" 
              size="large"
              @on-change="handleEnableChange"
            />
            <span class="switch-tip" :class="resourceModal.form.is_enabled == 1 ? 'text-success' : 'text-danger'">
              {{ resourceModal.form.is_enabled == 1 ? '已启用' : '已禁用' }}
            </span>
          </div>
          <div class="form-item-tip">开启后，该应用可以使用AI资源点服务</div>
        </FormItem>
        <FormItem label="封顶策略">
          <Select v-model="resourceModal.form.limit_mode" style="width: 100%;" placeholder="请选择封顶策略">
            <Option v-for="item in limitModeOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
          <div class="form-item-tip">设置资源点使用上限，防止超量使用</div>
        </FormItem>
        <FormItem label="封顶资源点" v-if="resourceModal.form.limit_mode !== 0">
          <InputNumber 
            v-model="resourceModal.form.limit_points" 
            :min="1" 
            :step="1000" 
            :precision="0"
            style="width: 100%;" 
            placeholder="请输入封顶资源点数量"
          />
          <div class="form-item-tip">
            {{ limitModeText(resourceModal.form.limit_mode) }}最多可使用 {{ resourceModal.form.limit_points || 0 }} 资源点
          </div>
        </FormItem>
        <FormItem label="期限限制">
          <div class="switch-wrapper">
            <i-Switch 
              v-model="resourceModal.form.expire_enabled" 
              :true-value="1" 
              :false-value="0" 
              size="large"
              @on-change="handleExpireEnableChange"
            />
            <span class="switch-tip" :class="resourceModal.form.expire_enabled == 1 ? 'text-success' : 'text-danger'">
              {{ resourceModal.form.expire_enabled == 1 ? '已启用' : '已禁用' }}
            </span>
          </div>
          <div class="form-item-tip">启用后，到期时间到达后将无法使用AI资源点服务（优先级高于封顶策略）</div>
        </FormItem>
        <FormItem label="到期时间" v-if="resourceModal.form.expire_enabled === 1">
          <DatePicker 
            v-model="resourceModal.form.expire_time" 
            type="datetime" 
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择到期时间"
            style="width: 100%;"
            :options="datePickerOptions"
          />
          <div class="form-item-tip">到期后将无法调用AI资源点服务，请及时续期</div>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="closeResourceModal" style="margin-right: 8px;">取消</Button>
        <Button type="primary" :loading="resourceModal.loading" @click="saveResourceConfig">保存配置</Button>
      </template>
    </Modal>
    <Modal v-model="deviceModal.show" title="添加库量" class-name="vertical-center-modal" @on-cancel="cancelDeviceModal">
      <Form :label-width="100" label-colon>
        <FormItem label="充值方式">
          <RadioGroup v-model="deviceModal.data.payType">
            <Radio :label="1" border>
              <span>微信支付</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="添加数量">
          <InputNumber
              style="width: 100%;"
              v-model="deviceModal.data.number"
              :max="99999" :min="1"
              :formatter="value => `${value} / 台`"
              :parser="value => value.replace(' / 台', '')" />
          <div style="margin-top: 8px;">设备流量套餐：{{ deviceModal.money }}元/台</div>
          <div>需支付：<span style="color: #ed4014;">￥ {{ deviceModalPrice }}</span></div>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="cancelDeviceModal">取消</Button>
        <Button type="primary" @click="confirmDeviceModal">确定</Button>
      </template>
    </Modal>
    <Modal v-model="payModal.show" @on-cancel="cancelPayModal()" :mask-closable="false" footer-hide class-name="vertical-center-modal" width="500">
      <template #header>
        <div style="text-align: center; width: 100%; font-weight: bold; font-size: 22px;">微信支付</div>
      </template>
      <vue-qr :text="payModal.code_url" :size="468" />
    </Modal>
  </div>
</template>

<script>
import Uploads from '@/components/common/Uploads'
import vueQr from 'vue-qr'
export default {
  name: 'Home',
  components: {
    Uploads,
    vueQr
  },
  data () {
    return {
      ApiUrl: this.ApiUrl,
      user: JSON.parse(localStorage.getItem('userInfo')),
      datetime: null,
      siteItem: [],
      sum: {
        site: 0,
        message: 0,
        ai: 0,
        hardware: 0
      },
      aiConfig: {},
      limitModeOptions: [
        { label: '不限', value: 0 },
        { label: '按日封顶', value: 1 },
        { label: '按周封顶', value: 2 },
        { label: '按月封顶', value: 3 }
      ],
      datePickerOptions: {
        disabledDate: (date) => {
          // 不允许选择过去的日期
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      search: {
        pageSize: 10,
        page: 1,
        total: 0,
        name: '',
        secret_id: ''
      },
      loading: false,
      data: [],
      addModal: {
        show: false,
        data: {
          name: '',
          thumb: '',
          dev_forward_url: '',
          forwardStart: 'https',
          ip_white_list: ''
        }
      },
      deviceModal: {
        show: false,
        money: 0.01,
        item: {},
        data: {
          payType: 1,
          number: 1
        }
      },
      resourceModal: {
        show: false,
        loading: false,
        title: '',
        form: {
          cloud_apply_id: null,
          is_enabled: 1,
          limit_mode: 0,
          limit_points: null,
          expire_enabled: 0,
          expire_time: null
        }
      },
      payModal: {
        show: false,
        code_url: '',
        orderInterval: null
      }
    }
  },
  computed: {
    deviceModalPrice () {
      return this.deviceModal.data.number * this.deviceModal.money
    }
  },
  mounted () {
    const _this = this
    setInterval(function () {
      _this.datetime = _this.getDateTime()
    }, 1000)
  },
  created () {
    if (this.$store.state.userInfo.uid) {
      this.init()
    }
  },
  methods: {
    init () {
      this.loading = true
      this.requestApi('/adm/get_index', this.search).then(listRes => {
        if (listRes.status === 1) {
          this.data = listRes.data.data
          this.search.total = listRes.data.total
          
          // 设置AI资源点配置信息
          this.aiConfig = {}
          if (this.data && this.data.length > 0) {
            this.data.forEach(item => {
              if (item.ai_config) {
                this.aiConfig[item.id] = {
                  is_enabled: item.ai_config.is_enabled || 0,
                  limit_mode: item.ai_config.limit_mode || 0,
                  limit_points: item.ai_config.limit_points || null,
                  expire_enabled: item.ai_config.expire_enabled || 0,
                  expire_time: item.ai_config.expire_time || null
                }
              }
            })
          }
        } else {
          this.data = []
          this.search.total = 0
          this.aiConfig = {}
          this.alertErr(listRes.msg || '获取应用列表失败')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.aiConfig = {}
        this.alertErr('数据加载失败，请稍后重试')
      })
    },
    aiConfigInfo (id) {
      return this.aiConfig[id] || { is_enabled: 0, limit_mode: 0, limit_points: null, expire_enabled: 0, expire_time: null }
    },
    aiEnableText (id) {
      return this.aiConfigInfo(id).is_enabled ? '已开启' : '未开启'
    },
    limitModeText (mode) {
      const map = {
        1: '每日封顶',
        2: '每周封顶',
        3: '每月封顶'
      }
      return map[mode] || ''
    },
    limitDisplay (id) {
      const config = this.aiConfigInfo(id)
      if (config.limit_mode === 0 || !config.limit_points) {
        return '不限'
      }
      return `${this.limitModeText(config.limit_mode)} ${config.limit_points} 点`
    },
    isExpired (id) {
      const config = this.aiConfigInfo(id)
      if (config.expire_enabled === 1 && config.expire_time) {
        const expireTime = new Date(config.expire_time).getTime()
        const currentTime = Date.now()
        return currentTime > expireTime
      }
      return false
    },
    formatExpireTime (id) {
      const config = this.aiConfigInfo(id)
      if (config.expire_enabled === 1 && config.expire_time) {
        const expireTime = new Date(config.expire_time)
        const year = expireTime.getFullYear()
        const month = String(expireTime.getMonth() + 1).padStart(2, '0')
        const day = String(expireTime.getDate()).padStart(2, '0')
        const hours = String(expireTime.getHours()).padStart(2, '0')
        const minutes = String(expireTime.getMinutes()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}`
      }
      return '未设置'
    },
    openResourceModal (item) {
      const config = this.aiConfigInfo(item.id)
      this.resourceModal.show = true
      this.resourceModal.loading = false
      this.resourceModal.title = item.name
      // 确保is_enabled是数字类型，Switch组件需要数字类型才能正确切换
      const isEnabled = config.is_enabled === 1 || config.is_enabled === '1' || config.is_enabled === true ? 1 : 0
      const expireEnabled = config.expire_enabled === 1 || config.expire_enabled === '1' || config.expire_enabled === true ? 1 : 0
      this.resourceModal.form = {
        cloud_apply_id: item.id,
        is_enabled: isEnabled,
        limit_mode: Number(config.limit_mode || 0),
        limit_points: config.limit_mode === 0 ? null : (config.limit_points || null),
        expire_enabled: expireEnabled,
        expire_time: config.expire_time || null
      }
    },
    closeResourceModal () {
      this.resourceModal.show = false
    },
    handleEnableChange (value) {
      // Switch切换时的处理
      // value 是 Switch 返回的值，根据 true-value / false-value 设置
      this.resourceModal.form.is_enabled = value === 1 || value === true ? 1 : 0
    },
    handleExpireEnableChange (value) {
      // 期限限制开关切换时的处理
      this.resourceModal.form.expire_enabled = value === 1 || value === true ? 1 : 0
      // 如果关闭期限限制，清空到期时间
      if (value === 0 || value === false) {
        this.resourceModal.form.expire_time = null
      }
    },
    saveResourceConfig () {
      const form = { ...this.resourceModal.form }
      
      // 验证必填字段
      if (!form.cloud_apply_id) {
        return this.alertErr('应用ID不能为空')
      }
      
      // 验证封顶资源点
      if (form.limit_mode !== 0) {
        if (!form.limit_points || form.limit_points <= 0) {
          return this.alertErr('请填写有效的封顶资源点')
        }
        form.limit_points = parseInt(form.limit_points)
      } else {
        form.limit_points = null
      }
      
      // 验证期限限制配置
      form.expire_enabled = form.expire_enabled === 1 || form.expire_enabled === true ? 1 : 0
      if (form.expire_enabled === 1) {
        if (!form.expire_time) {
          return this.alertErr('启用期限限制时，请选择到期时间')
        }
        // 确保日期时间格式正确
        if (form.expire_time instanceof Date) {
          // 如果是Date对象，转换为字符串
          const year = form.expire_time.getFullYear()
          const month = String(form.expire_time.getMonth() + 1).padStart(2, '0')
          const day = String(form.expire_time.getDate()).padStart(2, '0')
          const hours = String(form.expire_time.getHours()).padStart(2, '0')
          const minutes = String(form.expire_time.getMinutes()).padStart(2, '0')
          const seconds = String(form.expire_time.getSeconds()).padStart(2, '0')
          form.expire_time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
      } else {
        form.expire_time = null
      }
      
      // 确保数据类型正确
      form.cloud_apply_id = parseInt(form.cloud_apply_id)
      form.is_enabled = form.is_enabled === 1 || form.is_enabled === true ? 1 : 0
      form.limit_mode = parseInt(form.limit_mode)
      
      this.resourceModal.loading = true
      
      // 发送请求，确保数据格式正确
      this.requestApi('/adm/save_app_config', form).then(res => {
        this.resourceModal.loading = false
        if (res.status === 1) {
          this.alertSucc('保存成功')
          // 更新本地配置缓存
          this.aiConfig[form.cloud_apply_id] = {
            is_enabled: form.is_enabled,
            limit_mode: form.limit_mode,
            limit_points: form.limit_mode === 0 ? null : form.limit_points,
            expire_enabled: form.expire_enabled,
            expire_time: form.expire_time,
            updated_at: this.getDateTime(new Date())
          }
          this.closeResourceModal()
          // 刷新应用列表以更新显示
          this.init()
        } else {
          this.alertErr(res.msg || '保存失败')
        }
      }).catch((err) => {
        this.resourceModal.loading = false
        console.error('保存资源点配置失败:', err)
        if (err.response) {
          // 服务器返回了错误响应
          const msg = err.response.data?.msg || err.response.data?.error || '请求失败'
          this.alertErr(msg)
        } else if (err.request) {
          // 请求已发出但没有收到响应
          this.alertErr('网络错误，请检查网络连接')
        } else {
          // 其他错误
          this.alertErr('请求失败，请稍后重试')
        }
      })
    },
    pageChange (page) {
      this.search.page = page
      this.init()
    },
    pageSizeChange (size) {
      this.search.page = 1
      this.search.pageSize = size
      this.init()
    },
    resetSearch () {
      this.search.name = ''
      this.search.secret_id = ''
      this.search.page = 1
      this.init()
    },
    getDateTime () {
      var date = new Date()
      var y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        h = this.sendDate(date.getHours()),
        i = this.sendDate(date.getMinutes()),
        s = this.sendDate(date.getSeconds())
      date = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s
      return date
    },
    sendDate (d) {
      if (parseInt(d) < 10) {
        d = '0' + d
      }
      return d
    },
    cancelModal () {
      this.addModal.show = false
      this.addModal.data = {
        name: '',
        thumb: '',
        dev_forward_url: '',
        forwardStart: 'https',
        ip_white_list: ''
      }
    },
    confirmModal () {
      if (!this.addModal.data.name) {
        return this.alertErr('请输入应用名称！')
      }
      if (!this.addModal.data.dev_forward_url) {
        return this.alertErr('请输入回调地址！')
      }
      let data = JSON.parse(JSON.stringify(this.addModal.data))
      data.dev_forward_url = data.forwardStart + '://' + data.dev_forward_url
      this.$delete(data, 'forwardStart')
      this.requestApi('/adm/add_external_apply', { data }).then((res) => {
        if (res.status === 1) {
          this.alertSucc('添加成功')
          this.cancelModal()
          this.init()
        } else {
          this.alertErr(res.msg)
        }
      })
    },
    uploadSuccess (res) {
      if (res.status === 1) {
        res.pic_url = res.pic_url.indexOf('/uploads') > -1 ? this.ImgUrl + res.pic_url : 'https://' + res.pic_url
        this.addModal.data.thumb = res.pic_url
      } else {
        this.alertErr(res.msg)
      }
    },
    openDeviceModal (item) {
      this.deviceModal.show = true
      this.deviceModal.item = item
      this.requestApi('/adm/get_package_money').then(res => {
        if (res.status) {
          this.deviceModal.money = res.data
        }
      })
    },
    cancelDeviceModal () {
      this.deviceModal.show = false
      this.deviceModal.data = {
        number: 1
      }
    },
    confirmDeviceModal () {
      let data = {
        apply_id: this.deviceModal.item.id,
        number: this.deviceModal.data.number
      }
      this.requestApi('/adm/create_external_apply_order', { data }).then(res => {
        if (res.status === 1) {
          this.cancelDeviceModal()
          this.payModal.show = true
          this.payModal.code_url = res.data.code_url
          this.payModal.orderInterval = setInterval(() => {
            this.requestApi('/adm/get_package_order_status', {
              order_number: res.data.order_number
            }).then(res => {
              if (res.data === 1) {
                this.cancelPayModal()
                this.alertSucc('支付成功')
                this.init()
              }
            })
          }, 500)
        } else {
          this.alertErr(res.msg)
        }
      })
    },
    cancelPayModal () {
      clearInterval(this.payModal.orderInterval)
      this.payModal.show = false
      this.payModal.code_url = ''
      this.payModal.orderInterval = null
    }
  }
}
</script>

<style scoped>

/* 主容器 */
.home-container {
  padding: 16px;
  background: #f5f7f9;
  min-height: calc(100vh - 64px);
}

/* 搜索卡片 */
.search-card {
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-card .ivu-card-body {
  padding: 16px 20px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.search-form .ivu-form-item {
  margin-bottom: 0 !important;
  margin-right: 16px;
}

.search-input {
  width: 280px;
}

.search-btn {
  padding: 0 24px;
}

/* 应用列表卡片 */
.app-list-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.app-list-card .ivu-card-body {
  padding: 16px 20px;
}

.card-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #17233d;
  margin: 0;
}

.card-title .ivu-icon {
  margin-right: 8px;
  color: #2d8cf0;
}

.add-app-btn {
  border-radius: 6px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.add-app-btn .ivu-icon {
  margin-right: 6px;
  font-size: 16px;
}

.app-list-wrapper {
  min-height: 300px;
}

/* 应用卡片 */
.apply-item {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #e8eaec;
  border-radius: 12px;
  position: relative;
  margin-bottom: 20px;
  background: #fff;
  transition: all 0.3s ease;
  overflow: hidden;
  height: 100%;
}

.apply-item:hover {
  border-color: #2d8cf0;
  box-shadow: 0 6px 20px rgba(45, 140, 240, 0.12);
  transform: translateY(-4px);
}

.apply-item .item-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #43CF7C 0%, #2d8cf0 100%);
  color: #fff;
  padding: 4px 12px;
  border-radius: 0 12px 0 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(67, 207, 124, 0.25);
  z-index: 1;
}

.apply-item .item-img {
  width: 120px;
  height: 120px;
  margin: 24px auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.apply-item:hover .item-img {
  transform: scale(1.05);
}

.apply-item .item-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.apply-item .item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.apply-item .item-info .info-title {
  font-size: 18px;
  font-weight: 600;
  color: #17233d;
  text-align: center;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #515a6e;
  line-height: 1.6;
  padding: 2px 0;
}

.info-row .ivu-icon {
  color: #808695;
  flex-shrink: 0;
  opacity: 0.7;
}

.info-label {
  color: #808695;
  flex-shrink: 0;
  font-size: 12px;
}

.info-value {
  color: #17233d;
  font-weight: 500;
  font-size: 13px;
}

.info-link {
  color: #2d8cf0;
  cursor: pointer;
  margin-left: auto;
  transition: color 0.2s;
}

.info-link:hover {
  color: #5cadff;
  text-decoration: underline;
}

.info-ai {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px dashed #e8eaec;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  padding: 2px 0;
}

.ai-row .ivu-icon {
  color: #808695;
  flex-shrink: 0;
  opacity: 0.7;
}

.ai-row .info-label {
  font-size: 12px;
}

.item-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.action-btn,
.action-btn-primary {
  flex: 1;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 16px;
}

.action-btn-primary {
  background: linear-gradient(135deg, #2d8cf0 0%, #5cadff 100%);
  border: none;
}

.action-btn-primary:hover {
  background: linear-gradient(135deg, #5cadff 0%, #2d8cf0 100%);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #c5c8ce;
}

.empty-state .ivu-icon {
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 14px;
  color: #808695;
}

/* 分页 */
.page-r {
  margin-top: 16px;
  text-align: right;
  padding-top: 16px;
}

/* 资源点配置弹窗样式优化 */
.resource-config-modal .ivu-form-item {
  margin-bottom: 24px;
}

.resource-config-modal .ivu-form-item-label {
  font-weight: 500;
  color: #515a6e;
}

.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.switch-tip {
  font-size: 14px;
  font-weight: 500;
}

.switch-tip.text-success {
  color: #19be6b;
}

.switch-tip.text-danger {
  color: #ed4014;
}

.form-item-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #808695;
  line-height: 1.5;
}

.resource-config-modal .ivu-modal-footer {
  text-align: right;
  padding: 16px 24px;
  border-top: 1px solid #e8eaec;
}

.resource-config-modal .ivu-modal-body {
  padding: 24px;
}

.resource-config-modal .ivu-switch-large {
  min-width: 56px;
  height: 28px;
  line-height: 26px;
}

.resource-config-modal .ivu-switch-large .ivu-switch-inner {
  font-size: 12px;
  color: #fff;
}

.resource-config-modal .ivu-switch-large::after {
  width: 24px;
  height: 24px;
  top: 2px;
}

.resource-config-modal .ivu-switch-large.ivu-switch-checked::after {
  left: 30px;
}

.resource-config-modal .ivu-switch-large.ivu-switch-checked {
  background-color: #19be6b;
  border-color: #19be6b;
}

/* 响应式优化 */
@media (max-width: 1200px) {
  .search-input {
    width: 240px;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 16px;
  }
  
  .search-input {
    width: 100%;
    margin-bottom: 12px;
  }
  
  .summary-value {
    font-size: 24px;
  }
  
  .apply-item {
    padding: 20px;
  }
}
</style>
